import React, { useContext } from 'react';
import { ResponsiveContext } from 'grommet';
import { PageWrap } from 'components/Containers';
import { Banner } from './Sections/Banner';
import { Products } from './Sections/Products';
import { Faq } from './Sections/Faq';
import { Subscribe } from './Sections/Subscribe';
import styles from './Home.module.scss';

const Home = () => {
  const size = useContext(ResponsiveContext);

  return (
    <PageWrap
      background="new-page-background"
      gap="80px"
      pad={{ bottom: '80px', horizontal: '0px', top: '0px' }}
      className={styles.homePage}
    >
      {/* <CoinTracker vhLoader={true} /> */}
      <Banner size={size} />
      {/* <TradeSection /> */}
      <Products size={size} />
      <Faq size={size} />
      <Subscribe size={size} />
    </PageWrap>
  );
};

export default Home;
